import { Injectable } from '@angular/core';
import { updateStateServiceRequestCompleted } from '@common/store/service-request-completed/service-request-completed.actions';
import { getDataServiceRequestCompleted } from '@common/store/service-request-completed/service-request-completed.selector';
import {
  ServiceRequestCompletedState,
  ServiceRequestCompletedStore,
} from '@common/store/service-request-completed/service-request-completed.state';
import { SupportClass } from '@lib/components/support-class';
import { Store, select } from '@ngrx/store';
import { Observable, filter } from 'rxjs';
import { deepCopy } from '@common/helpers';

@Injectable({ providedIn: 'root' })
export class ServiceRequestCompletedStoreService extends SupportClass {
  private _storeCurrentValueSubscription$: Observable<ServiceRequestCompletedState>;
  private _storeCurrentValue!: ServiceRequestCompletedState;

  get storeCurrentValue() {
    return this._storeCurrentValue;
  }

  constructor(private _store: Store<ServiceRequestCompletedStore>) {
    super();
    this._storeCurrentValueSubscription$ = this._store.pipe(
      select(getDataServiceRequestCompleted),
      filter((data) => !!data)
    );
    this.subscribeService('ServiceRequestCompletedServiceData', this._storeCurrentValueSubscription$, (data) => {
      this._storeCurrentValue = data;
    });
  }

  public updateStateServiceRequestCompleted(value: ServiceRequestCompletedState) {
    this._store.dispatch(updateStateServiceRequestCompleted({ ...deepCopy(this.storeCurrentValue), ...value }));
  }

  destroy() {}
}
